export const environment = {
  production: false,
  baseUrl: 'https://api.thehouseofedge.com/api',
  clientId: '829354168232-tgisiuqeaiu7jin4lsrejoe6mbtt7fin.apps.googleusercontent.com',
  metaPixelId: '755163580878634',
  whatsappNumber: '919725473262',
  whatsappDefaultMessage: 'Hi, I have a query regarding my order/product.'
};
